import { CommonModule } from '@angular/common';
import { ModuleWithProviders, NgModule } from '@angular/core';

import { ENVIRONMENT, EnvironmentService } from './environment.service';
import { RawEnv } from './environment.types';

@NgModule({
  imports: [CommonModule]
})
export class EnvironmentModule {
  public static forRoot(environment: RawEnv): ModuleWithProviders<EnvironmentModule> {
    return {
      ngModule: EnvironmentModule,
      providers: [
        EnvironmentService,
        {
          provide: ENVIRONMENT,
          useValue: environment
        }
      ]
    };
  }
}

export * from './environment.service';
export * from './environment.types';
